module.exports = __webpack_public_path__ + "static/media/milxc-topology.3ba7174c.png";